"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartDrawer = void 0;
var SmartDrawer_1 = require("./SmartDrawer");
Object.defineProperty(exports, "SmartDrawer", { enumerable: true, get: function () { return __importDefault(SmartDrawer_1).default; } });
//# sourceMappingURL=index.js.map